import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const SearchSection = styled.div<{ $disabled?: boolean }>`
    align-items: center;
    border-bottom: 1px solid ${theme.colors.border.muted};
    box-sizing: content-box;
    color: ${(props) => (props.$disabled ? theme.colors.foreground.disabled : theme.colors.foreground.subtle)};
    display: flex;
    flex: none;
    gap: ${theme.space[8]};
    height: 32px;
    padding: ${theme.space[4]} ${theme.space[12]};
`;
